import "./App.css";
import "./styles/admin.scss";
import "boxicons/css/boxicons.min.css";

import Home from "./screens/Home";
import Login from "./screens/Login";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Routes, Route } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
import Auth, { UserContext } from "./components/context/userContext";
import DashBoard from "./screens/DashBoard";
import Acceuil from "./screens/Acceuil";
import ShopScreen from "./screens/ShopScreen";
import ProductDetailsScreen from "./screens/ProductDetails";
import CartScreen from "./screens/CardScreen";
import LoginScreen from "./screens/LoginScreen";
import RegisterScreen from "./screens/RegisterScreen";
import CheckoutScreen from "./screens/CheckoutScreen";
import Profile from "./screens/Profile";
import ForgetPass from "./screens/ForgetPass";
import ResetPassword from "./screens/ResetPassword";
import DashBoardAdmin from "./screens/DashBoardAdmin";
import Categories from "./screens/Categories";
import SubCategories from "./screens/SubCategories";
import Products from "./screens/Products";
import Packages from "./screens/Packages";
import Orders from "./screens/Orders";
import NotFound from "./components/NotFound";
import AboutUs from "./screens/AboutUs";
import PackageDetailsScreen from "./screens/PackageDetailsScreen";
import ProtectedIn from "./components/ProtectedIn/ProtectedIn";
import { useContext } from "react";
import ProtectedOut from "./components/ProtectedOut/ProtectedOut";
import PrivacyPolicy from "./screens/PolicyScreen/PolicyScreenn";
import SubCategoryScreen from "./screens/SubCategoryScreen/SubCategoryScreen";
import UsersScreen from "./screens/UsersScreen/UsersScreen";
const App = () => {
  const { doLogin, isAuthenticated } = useContext(UserContext);

  return (
    <div>
      <ToastContainer />
      <Router>
        <Auth>
          <Routes>
            <Route path="/" element={<Acceuil />} />
            <Route path="/acceuil" element={<Acceuil />} />
            <Route path="/shop" element={<ShopScreen />} />
            <Route
              path="/product-details/:productId"
              element={<ProductDetailsScreen />}
            />
            <Route
              path="/package-details/:packageId"
              element={<PackageDetailsScreen />}
            />
             <Route
              path="/sub-category/:subCategoryId"
              element={<SubCategoryScreen />}
            />
              <Route
              path="/policy"
              element={<PrivacyPolicy />}
            />
            <Route path="/card" element={<CartScreen />} />
            <Route path="/login" element={<LoginScreen />} />
            <Route
              path="/login"
              element={
                <ProtectedIn>
                  <LoginScreen />
                </ProtectedIn>
              }
            />
            <Route path="/signup" element={<RegisterScreen />} />
            <Route
              path="/checkout"
              element={
                <ProtectedOut>
                  <CheckoutScreen />
                </ProtectedOut>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedOut>
                  <Profile />
                </ProtectedOut>
              }
            />
            {/* <Route path="/forgetpassword" element={<ForgetPass />} /> */}
            {/* <Route path="/:userId/:resetString" element={<ResetPassword />} /> */}
            <Route path="/about-us" element={<AboutUs />} />

            <Route path="/dashboard-admin" element={<DashBoardAdmin />} />
            <Route
              path="/dashboard-admin/categories"
              element={<Categories />}
            />
            <Route
              path="/dashboard-admin/subCategories"
              element={<SubCategories />}
            />
            <Route path="/dashboard-admin/products" element={<Products />} />
                        <Route path="/dashboard-admin/users" element={<UsersScreen />} />

            <Route path="/dashboard-admin/packages" element={<Packages />} />
            <Route path="/dashboard-admin/orders" element={<Orders />} />
            <Route path="/*" element={<NotFound />} />
          </Routes>
        </Auth>
      </Router>
    </div>
  );
};

export default App;
